import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { Button, message, Popconfirm, Modal } from 'antd';
import { CampaignGetSingle } from '../../../../apis/Brand/Campaigns/CampaignGetSingle';
import { useHistory } from 'react-router-dom';
import { dispatch, useGlobalState } from '../../../../store/state';
import CurrencyIcon from '../../../Common/CurrencyIcon';
import { CheckBalance } from '../../../../apis/Brand/Credit/CheckBalance';
import { CampaignSubmit } from '../../../../apis/Brand/Campaigns/CampaignSubmit';
import CreativeCardsPreview from './CreativeCardsPreview';
import CampSubmitCard from './CampSubmitCard';
import './CampSubmitComponent.styles.scss';
import { checkObjectKeyValues } from '../../../../utils';
import { SyncCampiagnData } from '../../../../utils/SyncCampiagnData';

const CampSubmitComponent = () => {
  const history = useHistory();
  const [company] = useGlobalState('company');
  const [user] = useGlobalState('user');
  const [campDefSet] = useGlobalState('campDefSet');
  const [create_camp_draft] = useGlobalState('create_camp_draft');
  const [preview, setPreview] = useState(null);
  // const params = useParams()
  useEffect(()=>{
    // @note: load existing details
    CampaignGetSingle(user.accessToken, create_camp_draft.campaignid).then(({ status, response })=>{
      if (status === 200) {
        setPreview({
          ...preview,
          ...response,
        });
      } else {
        message.error('There is some issue with getting preview data');
      }
    });
    // @note: load credit related details
    CheckBalance(user.accessToken, company.selected.id).then(({ status, response })=> {
      if (status === 200) {
        dispatch({
          type: 'SET_COMPANY',
          payload: {
            ...company,
            credit: {
              ...company.credit,
              balance: response.wallet_balance,
            },
          },
        });
      } else {
        console.log('error while getting balance', response);
        // message.error("There is some issue with getting balance amount")
      }
    });
  }, [create_camp_draft]);

  // @note: approval step before submission
  const proceedToSubmit = () =>{
    if (company.credit.balance >= preview.budget) {
      submitForReview();
    } else {
      Modal.confirm({
        closable: true,
        maskClosable: true,
        title: 'Campaign is ready to sent for review',
        // icon: <ExclamationCircleOutlined />,
        content: 'You do not have sufficient credits for campaign to go live. We request to buy credits in the next 24hrs',
        okText: 'Buy Credits',
        cancelText: 'Later',
        onOk: reDirectToCredits,
        onCancel: submitForReview,
      });
    }
  };

  // @note making to credit page redirect
  const reDirectToCredits = () =>{
    console.log('let me addd credits');
    history.push(`/brand/${company.selected.id}/credit`);
  };

  // @note: submission Campaign for review
  const submitForReview = () => {
    console.log('let me submit for review');
    // CampaignSubmit(user.accessToken,create_camp_draft).then(({status,response}) => {
    //     console.log("res",response)
    // })

    SyncCampiagnData(
      create_camp_draft, // store sync object
      company.selected.id, // active company id
      campDefSet, // default field set for pre filter
      {
        campaignid: create_camp_draft.campaignid,
        data: checkObjectKeyValues(create_camp_draft), // prepared data or existing data
        returnOnly: true, // this option used to get data back only instead of sync in store
      }, // updated set of data to process
    ).then((data)=>{
      CampaignSubmit(user.accessToken, data).then(({ status, response }) => {
        console.log('res', response);
        if (status === 200) {
          message.success('Campaign Successfully submitted for review', 5);
          history.push(`/brand/${company.selected.id}/campaign`);
        } else {
          message.error(response.errors[0].msg, 6);
        }
      });
    });
  };
  return preview && (
    <div className="common_card camp_preview m-3 p-3 h-100">
      <h4 className="camp_preview--title mt-0">Review & Submit
        {/* <Button className="common_button float-right">
                    Submit for Review
                </Button> */}
        <div className="clearfix"></div>
      </h4>
      <div className="row">
        <div className="camp_preview_each px-3 my-3">
          <p className="camp_preview_each--title">Brand</p>
          <h6 className="camp_preview_each--value">{company.selected.companyname}</h6>
        </div>
        <div className="camp_preview_each px-3 my-3">
          <p className="camp_preview_each--title">Campaign ID</p>
          <h6 className="camp_preview_each--value">{preview.id || 'N/A'}</h6>
        </div>
        <div className="camp_preview_each px-3 my-3">
          <p className="camp_preview_each--title">Objective</p>
          <h6 className="camp_preview_each--value">{preview.objective || 'N/A'}</h6>
        </div>
        <div className="camp_preview_each px-3 my-3">
          <p className="camp_preview_each--title">Platform</p>
          <h6 className="camp_preview_each--value">{preview.platform || 'N/A'}</h6>
        </div>
        {/* <div className="camp_preview_each px-3 my-3">
                    <p className="camp_preview_each--title">Status</p>
                    <h6 className="camp_preview_each--value">{preview.campaignstatus}</h6>
                </div> */}
        {/* <div className="col-md-12"></div> */}
        {/* <div className="camp_preview_each px-3 my-3">
                    <p className="camp_preview_each--title">Total Creatives</p>
                    <h6 className="camp_preview_each--value">{preview.deliverables.length || 'Nil'}</h6>
                </div> */}
        <div className="camp_preview_each px-3 my-3">
          <p className="camp_preview_each--title">No. of influencers</p>
          <h6 className="camp_preview_each--value">{preview.influencerscount}</h6>
        </div>
        {/* <div className="camp_preview_each px-3 my-3">
                    <p className="camp_preview_each--title">No. of influencers</p>
                    <h6 className="camp_preview_each--value">{preview.influencerscount}</h6>
                </div> */}
        <div className="camp_preview_each px-3 my-3">
          <p className="camp_preview_each--title">Start Date</p>
          <h6 className="camp_preview_each--value">{preview.startdate ? moment(preview.startdate).format('Do, MMM YYYY hh:mm a'): 'N/A'}</h6>
        </div>
        <div className="camp_preview_each px-3 my-3 no-border">
          <p className="camp_preview_each--title">End Date</p>
          <h6 className="camp_preview_each--value">{preview.enddate ? moment(preview.enddate).format('Do, MMM YYYY hh:mm a'): 'N/A'}</h6>
        </div>
        {/* <div className="col-md-12"></div> */}
        {/* <div className="camp_preview_each px-3 my-3">
                    <p className="camp_preview_each--title">Total Cost</p>
                    <h6 className="camp_preview_each--value" style={{color:'var(--primary)'}}><CurrencyIcon /> {preview.budget || 'Nil'}</h6>
                </div>
                <div className="camp_preview_each px-3 my-3 no-border">
                    <p className="camp_preview_each--title">Credit Available</p>
                    {
                       (company.credit.balance >= preview.budget) ?(
                            <h6 className="camp_preview_each--value" style={{color:'green'}}>
                                <CurrencyIcon /> {company.credit.balance || 'nil'}
                            </h6>
                        ):(
                            <Tooltip title="You dont have enough balance, please consider refill wallet">
                                <h6 className="camp_preview_each--value" style={{color:'red'}}>
                                    <CurrencyIcon /> {company.credit.balance || 'nil'}
                                </h6>
                            </Tooltip>
                        )
                    }
                </div> */}
      </div>
      <div className="row">
        <div className="col-md-8">
          <CreativeCardsPreview deliverables={create_camp_draft.deliverables}/>
        </div>
        <div className="col-md-4">

          <CampSubmitCard balance={company.credit.balance}
            budget={preview.budget}>
            <Button className="common_button outlined w-100"
              onClick={proceedToSubmit}>Submit for Review</Button>
          </CampSubmitCard>
        </div>
      </div>
    </div>
  );
};

export default CampSubmitComponent;
